<template>
  <div class="container" style="height: 100%">
    <div :id="id" class="ezuikit_video"></div>
  </div>
</template>
<script>
import EZUIKit from 'ezuikit-js'
export default {
  props: {
    id: String,
    deviceUrl: String,
    accessToken: String
  },
  data() {
    return {
      player: ''
    }
  },
  created() {
    setTimeout(() => {
      this.initEZUIKit()
    }, 500)
  },
  methods: {
    // 初始化
    initEZUIKit() {
      console.group('mounted 组件挂载完毕状态===============》')
      this.player = new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: this.id,
        accessToken: this.accessToken,
        url: this.deviceUrl,
        template: 'simple', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        // 视频上方头部控件
        //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
        //plugin: ['talk'],                       // 加载插件，talk-对讲
        // 视频下方底部控件
        footer: ['hd', 'fullScreen'], // 如果template参数不为simple,该字段将被覆盖
        audio: 1 // 是否默认开启声音 0 - 关闭 1 - 开启
        // openSoundCallBack: data => console.log("开启声音回调", data),
        // closeSoundCallBack: data => console.log("关闭声音回调", data),
        // startSaveCallBack: data => console.log("开始录像回调", data),
        // stopSaveCallBack: data => console.log("录像回调", data),
        // capturePictureCallBack: data => console.log("截图成功回调", data),
        // fullScreenCallBack: data => console.log("全屏回调", data),
        // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
        // width: 600,
        // height: auto,
      })
    }
  }
}
</script>

<style type="text/css" scoped>
.container {
  background-color: #efefef;
  min-height: 100%;
  width: 100%;
}

.ezuikit_video {
  width: 100%;
  height: auto;
  min-height: 150px;

  overflow: hidden;
}
</style>

